import { CUSTOM_STYLES } from '../../../constants/styles';
import { TOP_SUGGEST_POSITION } from '../../../constants/routeControl';
export var makeCustomStyles = function makeCustomStyles(version, suggestPosition) {
  var styleVersion = version.replace(/\./g, '-');
  var styles = CUSTOM_STYLES.replace(/\{version\}/g, styleVersion);
  if (suggestPosition === 'top') {
    var suggestStyles = TOP_SUGGEST_POSITION.replace(/\{version\}/g, styleVersion);
    styles = "".concat(styles, " ").concat(suggestStyles);
  }
  return styles;
};